/*
  assets/mad-quote-submit.js (Worker C)
  Posts the shared step to the Zapier webhook with the same mechanics as before (text/plain JSON
  body, 12 second timeout, success only when the response is ok, generate_lead and Lead events),
  then opens /pages/quote-received when a HEAD probe says it exists, or shows the submit screen
  when it does not (one thank-you, Seth 2026-10-11). Every existing payload key stays; the new keys follow docs/wizard-contract.md
  section 11. The cart is never touched here, so a failed post leaves it intact.
  2026-09-25: lead tracking goes through window.madLead (layout/theme.liquid, HEAD workstream),
  called exactly once per lead_id after a confirmed 2xx; lead_id is kept for an identical retry
  after a failure, renewed when anything in the request changes, and renewed after a success.
  Trade (D6): trade_account and trade_discount; the draft note never calls an unverified request
  a tagged account. After a 2xx nothing can offer a second send: an error while drawing the
  success screen never shows "Something went wrong" and never re-enables Send.
  How did you find us? (SOURCE, answer 17, D-A6): found_via (one of the FOUND_VIA codes, '' when not
  answered) and found_via_other (Other only, up to 80 characters); referral_source is kept and carries the
  answer's plain label, which the deployed Zap prints as is. landing_page, landing_referrer,
  landing_utm_source and landing_date come from window.MadSource (snippets/mad-landing-source.liquid).
*/
(function () {
  'use strict';
  if (window.MadQuoteSubmit) return;

  var g = function (id) { return document.getElementById(id); };
  /* every existing key posts even when empty, so the Zap never sees a missing field */
  var ALWAYS = ['source', 'submitted_at', 'store_domain', 'cart_json', 'cart_total', 'item_count', 'full_name', 'email', 'phone',
    'sms_consent', 'fulfillment_method', 'shipping_street', 'shipping_city', 'shipping_state', 'shipping_zip', 'project_type', 'timeline',
    'target_date', 'referral_source', 'additional_comments', 'trade', 'trade_company', 'trade_proof_url', 'expedited', 'trade_account',
    'mad_hp_note'];

  /* "How did you find us?": the codes and short labels of snippets/mad-found-via.liquid, in its order
     (tests/unit/found-via.test.mjs keeps the two lists equal). */
  var FOUND_VIA = [
    ['google_search', 'Google search'], ['google_maps', 'Google Maps'], ['ai_assistant', 'AI assistant'],
    ['instagram_facebook', 'Instagram or Facebook'], ['pinterest', 'Pinterest'], ['etsy', 'Etsy'] /* Seth, 2026-09-25 evening */,
    ['friend_or_customer', 'A friend or past customer'], ['designer_or_builder', 'A designer or builder'], ['showroom', 'Saw the showroom'], ['other', 'Other']
  ];
  var LANDING_KEYS = ['landing_page', 'landing_referrer', 'landing_utm_source', 'landing_date'];
  function foundViaLabel(code) {
    for (var i = 0; i < FOUND_VIA.length; i++) if (FOUND_VIA[i][0] === code) return FOUND_VIA[i][1];
    return '';
  }
  /* found_via is a known code or ''; found_via_other is kept only for Other, on one line, at most 80
     characters. referral_source (an existing key) becomes the plain label, "Other: <what they typed>"
     for Other; with no answer it keeps whatever the form posted (an older page's chip row) or ''. */
  function applyFoundVia(out) {
    var code = String(out.found_via == null ? '' : out.found_via).trim();
    if (!foundViaLabel(code)) code = '';
    var other = code === 'other' ? String(out.found_via_other == null ? '' : out.found_via_other).replace(/\s+/g, ' ').trim().slice(0, 80) : '';
    out.found_via = code;
    out.found_via_other = other;
    if (code) out.referral_source = code === 'other' && other ? 'Other: ' + other : foundViaLabel(code);
    var land = {};
    try { land = window.MadSource && window.MadSource.read ? (window.MadSource.read() || {}) : {}; } catch (e) { land = {}; }
    LANDING_KEYS.forEach(function (k) { out[k] = typeof land[k] === 'string' ? land[k] : ''; });
    return out;
  }

  /* One id per quote request (plan item 5: dedupe and correlation). An identical retry after a failure
     reuses it, so a timeout that the Zap did receive is deduped; any change to what is sent (the
     estimate, a contact field, a comment) gets a new id, so a corrected request is never dropped as a
     duplicate of the first. leadSig is a hash of the payload without submitted_at and lead_id. */
  var leadId = null, leadSig = null, lastLeadId = null;
  function hash(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    return h.toString(36) + ':' + s.length;
  }
  function sigOf(data) {
    var keys = Object.keys(data).filter(function (k) { return k !== 'submitted_at' && k !== 'lead_id'; }).sort();
    return hash(keys.map(function (k) { return k + '=' + data[k]; }).join('\u0001'));
  }
  /* the estimate list changed (another door, an edit, a refresh, another tab): the next send is a new request */
  document.addEventListener('mad:estimate:changed', function (e) {
    var why = e && e.detail && e.detail.reason;
    if (why && why !== 'load' && why !== 'sent') { leadId = null; leadSig = null; }
  });

  /* QA Q-04, resend after an edit. After a 2xx, Send stays off while the estimate is the one that was sent
     (a second send would be a duplicate draft). Once the doors or their choices change (an edit, a door
     added or removed, an alternative, a new price; in the estimate list or in the cart), the dialog opens on
     the form again with Send ready and its usual header. estimateSig is what was quoted, not the contact
     fields; MadQuoteLines dispatches mad:quote:updated after every refresh. */
  var sentEstimate = null; /* { sig, ref } of the last request the Zap confirmed */
  function estimateSig(c) {
    if (!c) return '';
    return JSON.stringify([(c.lines || []).map(function (l) {
      /* slot 5 was the alternatives group, removed 2026-10-12; kept as '' so an estimate sent before still reads as sent */
      return [l.key, l.qty, l.doorPrice, l.raw ? JSON.stringify(l.raw) : '', '', l.product && l.product.variantId];
    }), c.total]);
  }
  function currentSig() {
    try { return window.MadQuoteLines ? estimateSig(window.MadQuoteLines.collect()) : ''; } catch (e) { return ''; }
  }
  function resetAfterChange() {
    sentEstimate = null;
    var btn = g('mad_cq_submit'); if (btn) btn.disabled = false;
    var status = g('mad_cq_status'); if (status) status.textContent = '';
    var m = g('mad-cq-modal');
    var label = m && m.querySelector('[data-mad-cq-progress]');
    if (label && label.hasAttribute('data-mad-default')) label.textContent = label.getAttribute('data-mad-default');
  }
  /* After a reload the page has forgotten the send, but the estimate list remembers it (markSent: the lead id,
     a hash of the estimate and its lead-time choice). While the list still holds exactly that estimate, the
     confirmation comes back with its reference and Send stays off; any change opens the form as usual. */
  function restoreSent() {
    var L = window.MadEstimateList && window.MadEstimateList.enabled ? window.MadEstimateList : null, m = null;
    try { m = L && L.count() > 0 ? L.meta() : null; } catch (e) { m = null; }
    if (!m || !m.sentAt || !m.leadId || !m.sentSig) return;
    var sig = currentSig();
    if (!sig || hash(sig) !== m.sentSig) return;
    sentEstimate = { sig: sig, ref: m.leadId, expedited: m.sentTimeline === 'expedited', drawn: false };
    var btn = g('mad_cq_submit'); if (btn) btn.disabled = true;
    try { showSuccess(window.MadQuoteLines.collect(), m.leadId, { expedited: sentEstimate.expedited }); sentEstimate.drawn = true; } catch (e) { /* the form opens instead */ }
  }
  /* MadQuoteForm.open asks first: 'sent' shows the confirmation again (nothing changed), 'form' the form.
     Since 2026-10-11 a send draws its sent screen only when the Quote received page cannot open, so a reopen (during
     the short wait before that page, or after Back) draws it first: never an empty "Quote request sent" box. */
  function reopen() {
    if (!sentEstimate) restoreSent();
    if (!sentEstimate) return 'form';
    if (currentSig() === sentEstimate.sig) {
      if (!sentEstimate.drawn) { try { showSuccess(window.MadQuoteLines.collect(), sentEstimate.ref, { expedited: !!sentEstimate.expedited }); sentEstimate.drawn = true; } catch (e) { /* the box keeps its words */ } }
      return 'sent';
    }
    resetAfterChange();
    return 'form';
  }
  document.addEventListener('mad:quote:updated', function (e) {
    if (sentEstimate && e && e.detail && estimateSig(e.detail) !== sentEstimate.sig) resetAfterChange();
  });
  function newLeadId() {
    var rnd = '';
    try { var a = new Uint32Array(2); window.crypto.getRandomValues(a); rnd = a[0].toString(36) + a[1].toString(36); } catch (e) { rnd = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2); }
    return 'mq-' + Date.now().toString(36) + '-' + rnd.slice(0, 12);
  }

  function formToObj(f) {
    var out = {};
    new FormData(f).forEach(function (v, k) { out[k] = v; }); /* last value wins; every field posts once */
    ALWAYS.forEach(function (k) { if (out[k] === undefined) out[k] = ''; });
    /* timeline is standard | expedited; expedited (yes | no) is derived from it so the Zap keeps working; no date is asked */
    out.expedited = out.timeline === 'expedited' ? 'yes' : 'no';
    out.target_date = '';
    return applyFoundVia(out);
  }

  /* Settings: this snippet's own #mad-cq-config (rendered from the same theme settings, and the only
     source of the newer keys such as contactEmail) wins; W's window.MadQuoteConfig fills anything missing. */
  function config() {
    var local = {};
    var el = g('mad-cq-config');
    try { local = el ? JSON.parse(el.textContent) : {}; } catch (e) { local = {}; }
    return Object.assign({}, window.MadQuoteConfig || {}, local);
  }

  /* "Clear tempered", "Diamond pattern", "English pattern": the estimate's own short names, capitalised */
  function glassName(code) {
    var E = window.MADEstimate, s = (E && E.GLASS_SHORT && E.GLASS_SHORT[code]) || String(code || 'replacement').replace(/_/g, ' ');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /* The open items the team settles on the call, one per line, so the draft order carries an agenda. */
  function draftNote(c, data) {
    var items = [];
    var E = window.MADEstimate, money = function (n) { return E ? E.money(n) : Number(n).toFixed(2); };
    c.quoted.forEach(function (l) {
      var r = l.raw || {};
      if (l.notMeasured) items.push(l.code + ': opening not measured yet, get the tape measurement on the call');
      else if (l.fitState === 'talk') items.push(l.code + ': the opening needs a conversation before anything is cut');
      if (l.deferred) items.push(l.code + ': Install Ready details (wall depth, swing, hinge finish, jamb grade) to confirm on the call');
      if (r.jamb_needed === 'not_sure') items.push(l.code + ': price both door only and Install Ready');
      if (r.pair_operation) items.push(l.code + ': French pair, ' + ({ both_active: 'both doors open', active_fixed: 'one active door and one fixed door', not_sure: 'how it opens not decided' }[r.pair_operation] || r.pair_operation)
        + ': confirm the hardware on the call (nothing priced on the site)');
      /* Glass (Seth, 2026-09-25, answer 8): Eric prices replacement glass by hand; no amount and no rate here (QA Q-01) */
      if (r.glass_panes === 'not_sure') items.push(l.code + ': ' + glassName(r.glass_work) + ' glass, pane sizes to confirm: glass priced by hand on the quote');
      if (r.glass_panes === undefined && E && E.glassOnCall && E.glassOnCall(r, window.MAD_PRICE_BOOK || {})) items.push(l.code + ': ' + glassName(r.glass_work) + ' glass, not priced on the site: glass priced by hand on the quote');
      if (r.glass_work === 'diamond_pattern' || r.glass_work === 'english_pattern') items.push(l.code + ': patterned glass, confirm with the customer whether it is tempered (still open)');
    });
    /* an older cart line whose saved choices could not be read (Codex re-check): the site priced the door alone */
    c.unpricedDoors.forEach(function (l) { items.push((l.code || l.title) + (l.rawUnreadable ? ': its saved choices could not be read on the site (door price only), price it on the call' : ': no choices saved on the site, price it on the call')); });
    if (data.expedited === 'yes') items.push('Expedited requested: quote the timing and the upcharge (the site showed no numbers)');
    /* Trade: only a logged-in customer with the trade tag is an account; a ticked box is a request. The model
       (Seth, 2026-09-25, answer 7): the first paid order on the account earns 10% store credit (Shopify Flow,
       when paid) and gets no discount; a customer with an earlier paid order gets 10% off the door lines only
       (the rule the prepared Flow and Zap version 2 use). */
    if (data.trade_account === 'yes') {
      items.push(c.tradeApplied
        ? 'Trade account (the logged-in customer has the trade tag): the site showed 10% off the doors only (' + money(c.tradeDiscount || 0) + '); the Zap applies it to the door lines when the customer record carries the tag trade; services and freight at full price'
        : 'Trade account (the logged-in customer has the trade tag; check the customer record): no earlier paid order on the account means this is their first order, so no discount on this quote (Shopify Flow adds the 10% store credit once it is paid); a customer with an earlier paid order gets 10% off the door lines only, services and freight at full price. The site said trade pricing is confirmed on the quote and showed no discounted total');
    } else if (data.trade === 'yes') {
      items.push('Trade pricing requested, account not verified: check ' + (data.trade_proof_url ? data.trade_proof_url : 'the proof they text over') + (data.trade_company ? ' (' + data.trade_company + ')' : ' (no company given)')
        + '; if approved, tag the customer trade: the first paid order on the account earns the 10% store credit (Shopify Flow, once paid, no discount on that quote); a customer with an earlier paid order gets 10% off the door lines only (services and freight at full price). The site showed no discount');
    }
    if (data.fulfillment_method === 'pickup') items.push('Pickup in Lafayette, no freight');
    else items.push('Freight to ZIP ' + (data.shipping_zip || '(not given)') + (data.shipping_state ? ', ' + data.shipping_state : '')
      + ' (' + ([data.shipping_street, data.shipping_city].filter(Boolean).join(', ') || 'street address missing') + ')');
    return 'Open items from the site:\n' + (items.length ? items.map(function (t) { return '- ' + t; }).join('\n') : '- none');
  }

  /* The number of lines the request carries: the cart just filled in, else the cart_json field as it will be posted. */
  function cartLines(cart) {
    if (cart && Array.isArray(cart.items)) return cart.items.length;
    try { var el = g('mad_cq_cart_json'), c = JSON.parse(decodeURIComponent(escape(atob((el && el.value) || '')))); return c && Array.isArray(c.items) ? c.items.length : 0; } catch (e) { return 0; }
  }

  function payload(f) {
    var data = formToObj(f);
    var c = window.MadQuoteLines ? window.MadQuoteLines.collect() : { quoted: [], unpricedDoors: [], total: 0, anyDeferred: false, priceBookVersion: '', tradeDiscount: 0, tradeApplied: false };
    /* trade_account comes from the page (Liquid saw the customer tag and marked [data-mad-trade-known]);
       the discount is only ever shown and sent for it. The Zap still verifies the tag. */
    data.trade_account = c.tradeKnown ? 'yes' : 'no';
    if (!c.tradeKnown) { c.tradeDiscount = 0; c.tradeApplied = false; c.total = c.subtotal !== undefined ? c.subtotal : c.total; }
    data.estimate_total = Number(c.total || 0).toFixed(2);
    data.trade_discount = Number(c.tradeDiscount || 0).toFixed(2);
    data.estimate_lines = JSON.stringify(c.quoted.map(function (l) {
      return { door: l.title, lines: (l.estimate ? l.estimate.lines : []).map(function (x) { return { label: x.label, amount: x.amount }; }), total: l.total };
    }));
    /* "Alternative to" was removed (Seth 2026-10-12: "it just over complicates things"): every door counts. The key stays
       in the payload (contract section 11) and is always 0.00. */
    data.alternatives_total = '0.00';
    data.price_book_version = c.priceBookVersion || '';
    data.details_deferred = c.anyDeferred ? 'yes' : 'no';
    data.fit_readout = c.quoted.map(function (l) { return l.title + ': ' + (l.fitState || 'none'); }).join('\n');
    data.draft_note = draftNote(c, data);
    var sig = sigOf(data);
    if (!leadId || sig !== leadSig) { leadId = newLeadId(); leadSig = sig; }
    data.lead_id = leadId;
    return { data: data, collected: c };
  }

  function showSuccess(c, ref, opts) {
    var m = g('mad-cq-modal'), f = g('mad-cq-form'), cfg = config();
    if (!m) return;
    var box = m.querySelector('[data-mad-cq-success]');
    if (f) f.hidden = true;
    var label = m.querySelector('[data-mad-cq-progress]');
    if (label) { if (!label.hasAttribute('data-mad-default')) label.setAttribute('data-mad-default', label.textContent); label.textContent = 'Sent'; }
    if (!box) return;
    var total = box.querySelector('[data-mad-success-total]');
    if (total) total.textContent = window.MadQuoteLines ? window.MadQuoteLines.money(c.total || 0) : '$' + Number(c.total || 0).toFixed(2);
    /* Lead time follows the timeline tile: expedited shows the expedited setting, standard shows shop work or no work. */
    var tr = box.querySelector('[data-mad-success-trade]');
    if (tr) {
      /* Trade (Seth, 2026-09-25, answer 7): the first paid order earns store credit, later orders 10% off the doors */
      tr.hidden = !c.tradeKnown;
      tr.textContent = !c.tradeKnown ? '' : c.tradeDiscount > 0
        ? 'Includes your trade discount of ' + (window.MadQuoteLines ? window.MadQuoteLines.money(c.tradeDiscount) : c.tradeDiscount) + ' on the doors.'
        : 'Trade account on file: we confirm your trade pricing on your quote.';
    }
    var lead = box.querySelector('[data-mad-lead-time]');
    if (lead) {
      /* opts.expedited: the choice that was sent, when the confirmation comes back after a reload */
      var exp = opts && typeof opts.expedited === 'boolean' ? opts.expedited : !!(window.MadQuoteForm && window.MadQuoteForm.expedited && window.MadQuoteForm.expedited());
      var kind = exp ? 'expedited' : (c.anyService ? 'shop_work' : 'no_work');
      var text = exp ? (cfg.expeditedText || lead.getAttribute('data-expedited'))
        : c.anyService ? (cfg.leadTimeShopWork || lead.getAttribute('data-shop-work')) : (cfg.leadTimeNoShopWork || lead.getAttribute('data-no-work'));
      text = String(text || '').trim();
      var label = lead.querySelector('[data-mad-lead-time-label]'); if (label) label.textContent = exp ? 'Timing, expedited:' : 'Timing:';
      var span = lead.querySelector('[data-mad-lead-time-text]'); if (span) span.textContent = text;
      var period = lead.querySelector('[data-mad-lead-time-period]'); if (period) period.textContent = /[.!?]$/.test(text) ? '' : '.';
      lead.setAttribute('data-mad-lead-kind', kind);
    }
    var un = box.querySelector('[data-mad-unmeasured-next]'); if (un) un.hidden = !c.anyUnmeasured;
    /* "one of one" is said of antiques only (Seth, 2026-09-26): not after a quote of handcrafted doors alone */
    var holdEl = box.querySelector('[data-mad-hold]'); if (holdEl) holdEl.hidden = c.anyAntique === false;
    /* plan item 5 acknowledgement: the reference id, and that this is a request, not a quote or a reservation */
    var refEl = box.querySelector('[data-mad-success-ref]');
    if (refEl) {
      var code = refEl.querySelector('[data-mad-success-ref-id]');
      if (code) code.textContent = ref || '';
      refEl.hidden = !ref;
    }
    box.hidden = false;
    var body = m.querySelector('.mad-dialog__body'); if (body) body.scrollTo(0, 0);
    var h = box.querySelector('h3'); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('#mad-cq-form');
    if (!f) return;
    e.preventDefault();
    if (window.MadQuoteForm && !window.MadQuoteForm.validateStep()) return;

    var btn = g('mad_cq_submit'), status = g('mad_cq_status');
    var url = f.getAttribute('data-webhook') || '';
    if (!url) { if (status) status.textContent = 'Configuration error. Webhook URL not set.'; return; }

    if (btn) btn.disabled = true;
    if (status) status.textContent = 'Checking your doors';
    var L = window.MadEstimateList && window.MadEstimateList.enabled ? window.MadEstimateList : null;
    var listOn = !!(L && L.count() > 0);
    var built = null, delivered2xx = false;
    var E0 = window.MADEstimate, label0 = function (t) { return E0 ? E0.doorLabel(t) : t; }, money0 = function (cents) { return E0 ? E0.money(cents / 100) : '$' + (cents / 100).toFixed(2); };

    /* Plan 5.4: refresh live price and availability of the estimate list first. A door that just sold
       stops the send with a plain sentence (the rest can be sent once it is removed); a changed door
       price stops it once, so the customer sees the new total before sending (the next Send goes). */
    (listOn ? L.refresh().catch(function () { return { sold: [], changed: [] }; }) : Promise.resolve({ sold: [], changed: [] })).then(function (pre) {
      if (pre.sold && pre.sold.length) {
        var cfg0 = config();
        if (window.MadQuoteLines && window.MadQuoteLines.renderList) window.MadQuoteLines.renderList();
        if (status) status.textContent = pre.sold.map(function (l) { return label0(l.product.title); }).join(', ')
          + ' just sold. Go back to your estimate and remove it to send the rest, or call ' + (cfg0.phone || '(337) 273-0189') + '.';
        if (btn) btn.disabled = false;
        return null;
      }
      if (pre.changed && pre.changed.length) {
        if (window.MadQuoteLines && window.MadQuoteLines.refresh) window.MadQuoteLines.refresh();
        if (window.MadQuoteForm && window.MadQuoteForm.syncEstimate) { try { window.MadQuoteForm.syncEstimate(); } catch (e) { /* display only */ } }
        if (status) status.textContent = pre.changed.map(function (x) { return 'The price of ' + label0(x.title) + ' changed from ' + money0(x.from) + ' to ' + money0(x.to); }).join('. ')
          + '. Check your estimate and send again.';
        if (btn) btn.disabled = false;
        return null;
      }
      if (window.MadQuoteLines && window.MadQuoteLines.renderList) window.MadQuoteLines.renderList();
      var fill = window.MadQuoteForm && window.MadQuoteForm.fillCart ? window.MadQuoteForm.fillCart() : Promise.resolve(null);
      return fill.then(function (cart) {
        /* Codex re-check: the Zap rejects more than 40 lines, after the webhook has already answered 200 (so the site
           would say "sent" and no draft would follow). Count the lines this request carries; over the limit, stop. */
        var QL = window.MadQuoteLines, n = cartLines(cart);
        if (QL && QL.QUOTE_LINE_LIMIT && n > QL.QUOTE_LINE_LIMIT) {
          if (status) status.textContent = QL.tooManyText(n, 0);
          if (btn) btn.disabled = false;
          return null;
        }
        built = payload(f);
        if (status) status.textContent = 'Sending your quote request';
        /* Zapier catch hooks allow cross-origin reads; text/plain keeps this a simple request (no preflight). */
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 12000);
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(built.data), signal: controller.signal })
          .then(function (resp) { clearTimeout(timer); return resp.ok; }, function () { clearTimeout(timer); return false; });
      });
    }).then(function (delivered) {
        if (delivered === null) return; /* stopped before sending */
        if (!delivered) {
          /* phone and email come from theme settings (mad_phone, mad_contact_email) so a new salesperson is a one-field change */
          var cfg = config(), phone = cfg.phone || '(337) 273-0189', href = cfg.phoneHref || 'tel:+13372730189', mail = cfg.contactEmail || '';
          var esc = function (s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
          if (status) status.innerHTML = 'Something went wrong sending your request. Please try again, '
            + 'or call us at <a href="' + esc(href) + '">' + esc(phone) + '</a>'
            + (mail ? ' or email <a href="mailto:' + esc(mail) + '">' + esc(mail) + '</a>' : '') + '.';
          if (btn) btn.disabled = false;
          return;
        }
        /* The request is delivered. From here on nothing may offer a second send (it would be a second
           draft under a new lead id): Send stays disabled and every step is guarded on its own. */
        delivered2xx = true;
        if (btn) btn.disabled = true;
        var ref = built.data.lead_id;
        lastLeadId = ref;
        var expedited = built.data.timeline === 'expedited';
        sentEstimate = { sig: estimateSig(built.collected), ref: ref, expedited: expedited, drawn: false }; /* QA Q-04: Send comes back once the estimate changes */
        leadId = null; leadSig = null; /* the next request is a new lead */
        var value = Number(built.data.estimate_total) || 0;
        try { trackLead(built.data, value); } catch (e) { /* tracking never blocks the customer */ }
        /* For /pages/quote-received (PAGES): the reference and the estimate, read back within the hour. Since 2026-10-11
           that page is the only thank-you, so it also gets what this form's own screen said: the not-measured next step,
           an expedited request, and the trade line (tradeKnown, tradeDiscount as this screen reads them). */
        var c0 = built.collected || {};
        try { window.sessionStorage.setItem('mad-quote-last', JSON.stringify({ total: value, t: Date.now(), id: ref, unpriced: (c0.unpricedDoors || []).length, unmeasured: !!c0.anyUnmeasured, expedited: expedited, tradeKnown: !!c0.tradeKnown, tradeDiscount: Number(c0.tradeDiscount) || 0 })); } catch (e) { /* the page hides the line */ }
        if (listOn) { try { L.markSent(ref, { sig: hash(sentEstimate.sig), timeline: expedited ? 'expedited' : 'standard' }); } catch (e) { /* the list is a convenience; the quote is sent */ } }
        try { document.dispatchEvent(new CustomEvent('mad:cq:sent', { detail: { estimate_total: built.data.estimate_total, lead_id: ref } })); } catch (e) { /* ignore */ }
        /* One thank-you (Seth 2026-10-11: "the thank you page shows up for like 5 seconds and then another one takes its
           place ... it feels like a glitch"). This form used to show its own sent screen for 5 seconds before the Quote
           received page replaced it. Now it only says the request was sent and opens that page once the lead tags have
           had a moment: 1.2 seconds, or longer while window.madLead.busy() says the Pinterest lead waits for Pinterest's
           script, plus 1 second after it loads so its own requests go out (the email match), never past 8 seconds; any
           tag still unsent resumes on the next page (docs/tracking.md section 4). Without that page (or with no answer in
           9 seconds) the sent screen shows here as before, and then the page never opens on top of it; nor does it when a
           reopen of this form has already drawn that screen. Back from the Quote received page restores this page from
           the browser's cache: the sent screen is drawn then (the review of 2026-10-11 found the form stuck on
           "Opening your confirmation"). */
        var sentAt = Date.now(), here = false, leaving = false, lastBusy = 0;
        var mine = sentEstimate;
        var showHere = function () {
          if (here || leaving) return;
          here = true;
          try {
            if (status) status.textContent = '';
            showSuccess(built.collected, ref, { expedited: expedited });
            mine.drawn = true;
          } catch (e) {
            if (status) status.textContent = 'Your quote request was sent. Your reference: ' + ref + '.';
          }
        };
        if (status) status.textContent = 'Request sent. Opening your confirmation...';
        var slow = setTimeout(showHere, 9000);
        try {
          fetch('/pages/quote-received', { method: 'HEAD' }).then(function (probe) {
            if (!probe.ok) { clearTimeout(slow); showHere(); return; }
            var leave = function () {
              if (here || mine.drawn) { clearTimeout(slow); return; }
              var busy = false, now = Date.now(), waited = now - sentAt;
              try { busy = !!(window.madLead && typeof window.madLead.busy === 'function' && window.madLead.busy()); } catch (e) { busy = false; }
              if (busy) lastBusy = now;
              var settling = !!lastBusy && now - lastBusy < 1000;
              if (waited < 1200 || ((busy || settling) && waited < 8000)) { setTimeout(leave, 250); return; }
              leaving = true; clearTimeout(slow);
              try { window.addEventListener('pageshow', function (ev) { if (ev && ev.persisted) { leaving = false; showHere(); } }, { once: true }); } catch (e) { /* older browsers */ }
              window.location.href = '/pages/quote-received?ref=' + encodeURIComponent(ref);
            };
            leave();
          }).catch(function () { clearTimeout(slow); showHere(); });
        } catch (e) { clearTimeout(slow); showHere(); }
      }).catch(function () {
        if (delivered2xx) return; /* sent: never re-enable Send or say it failed */
        /* never leave the button stuck; the estimate and the cart are untouched */
        if (btn) btn.disabled = false;
        if (status) status.textContent = 'Something went wrong. Please try again, or call ' + (config().phone || '(337) 273-0189') + '.';
      });
  });

  /* Exactly once per confirmed request, through window.madLead (snippets/mad-tracking.liquid, rendered by
     layout/theme.liquid), which dedupes by transaction_id and decides what is sent. At launch it sends what
     the old site sent for this form (docs/tracking.md section 2): both Google Ads actions, GA4 generate_lead
     and Meta Lead with value 0, and the Pinterest lead with the typed email (D14). The estimate is passed
     as value, but GA4 and Meta receive it only when an owner ticks mad_track_estimate_value. There is no
     direct gtag or fbq fallback: without madLead nothing is sent (the unit tests check that the layout
     renders it), so a preview or a broken merge can never count a test quote as a real conversion. */
  var tracked = {};
  function trackLead(data, value) {
    var id = data.lead_id;
    if (tracked[id]) return;
    tracked[id] = true;
    var detail = { form: 'quote', value: value, currency: 'USD', transaction_id: id, email: String(data.email || '').trim() || undefined };
    if (typeof window.madLead === 'function') { try { window.madLead(detail); } catch (e) { /* tracking never blocks the customer */ } }
  }

  window.MadQuoteSubmit = { payload: payload, draftNote: draftNote, showSuccess: showSuccess, formToObj: formToObj, trackLead: trackLead,
    FOUND_VIA: FOUND_VIA, foundViaLabel: foundViaLabel, reopen: reopen, estimateSig: estimateSig, sentEstimate: function () { return sentEstimate; },
    leadId: function () { return leadId; }, lastLeadId: function () { return lastLeadId; } };
})();
